var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-currency-field',{ref:"input",attrs:{"vbind":_vm.vbind,"options":_vm.options},on:{"input":function($event){return _vm.emitChange()}},model:{value:(_vm.computedValue),callback:function ($$v) {_vm.computedValue=$$v},expression:"computedValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }